import { api, unwrap } from "./httpClient";

export interface ProjectInvestment {
  id: number;
  userId: number;
  projectId: number;
  investmentOptionId: number;
  amount: number;
  expectedReturn: number;
  currency: string;
  status: "active" | "completed" | "cancelled";
  investedAt: string;
  maturityDate: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * Investit dans un projet
 */
export const investInProject = async (
  projectId: number,
  investmentOptionId: number
): Promise<ProjectInvestment> => {
  return unwrap<ProjectInvestment>(
    api({
      method: "POST",
      url: `/projects/${projectId}/invest`,
      data: { investmentOptionId },
    })
  );
};

/**
 * Récupère les investissements de l'utilisateur dans les projets
 */
export const getUserProjectInvestments = async (
  limit?: number,
  offset?: number
): Promise<ProjectInvestment[]> => {
  return unwrap<ProjectInvestment[]>(
    api({
      method: "GET",
      url: "/projects/investments",
      params: { limit, offset },
    })
  );
};

/**
 * Récupère un investissement spécifique
 */
export const getProjectInvestmentById = async (
  investmentId: number
): Promise<ProjectInvestment> => {
  return unwrap<ProjectInvestment>(
    api({
      method: "GET",
      url: `/projects/investments/${investmentId}`,
    })
  );
};



